import cssExtras from "refractor/css-extras";
export default cssExtras;